// The open-source components (31-legal.md, "Open-source components"): a dialog with every component
// of this build and its licence, the call app first with its source; the list ships with the app.
import { useEffect, useState } from 'react';
import { Button } from '../blocks/Button';
import { Dialog, DialogButtons } from '../blocks/Dialog';
import { Spinner } from '../blocks/Wait';
import { t } from '../i18n';

interface Entry {
  name: string;
  version?: string;
  licence: string;
  text: string;
  source?: string;
}

export function OpenSource({ onClose }: { onClose: () => void }) {
  const [entries, setEntries] = useState<Entry[]>();
  const [open, setOpen] = useState<string>();
  useEffect(() => void fetch('/licenses.json').then((r) => r.json()).then(setEntries, () => setEntries([])), []);
  return (
    <Dialog title={t('legal.openSource')} className="open-source" onClose={onClose}>
      <p className="dialog-text">{t('legal.openSourceLine')}</p>
      <div className="open-source-list">
        {!entries ? (
          <Spinner size={24} />
        ) : (
          entries.map((e) => {
            const key = `${e.name}@${e.version}`;
            return (
              <div key={key}>
                <button type="button" className="open-source-entry" aria-expanded={open === key} onClick={() => setOpen(open === key ? undefined : key)}>
                  {e.name}
                  {e.version ? ` ${e.version}` : ''} · {e.licence}
                </button>
                {e.source && (
                  <a href={e.source} target="_blank" rel="noopener noreferrer">
                    {t('legal.source', { version: e.version ?? '' })}
                  </a>
                )}
                {open === key && <pre>{e.text}</pre>}
              </div>
            );
          })
        )}
      </div>
      <DialogButtons>
        <Button variant="text" onClick={onClose}>
          {t('common.close')}
        </Button>
      </DialogButtons>
    </Dialog>
  );
}
